import React from "react";

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            Copyright © 2023 Bunny. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
